module.exports = __webpack_public_path__ + "static/img/ubi_desk_logo_3.21e645aa.png";